import { createLogger, format, transports, LogEntry, add } from "winston";
import WinstonCloudWatch, {
  CloudwatchTransportOptions,
} from "winston-cloudwatch";
import { environment } from "./Environment";

export interface LogMeta {
  user: string | null;
  tags: string;
  body: any;
}
const { combine, splat, timestamp, printf } = format;

const consoleLogFormat = printf(
  ({ level, message, timestamp, ...metadata }): string => {
    let msg = `${timestamp} ${level}: ${message} `;
    if (metadata) msg += JSON.stringify(metadata);

    return msg;
  }
);

const awsLogFormat = ({ level, message, additionalInfo }: LogEntry): string => {
  let obj = {
    level,
    message,
    meta: additionalInfo,
    request: window.location.pathname,
  };

  return JSON.stringify(obj);
};

const logger = createLogger({
  level: process.env.NODE_ENV === "production" ? "info" : "debug",
  transports: [
    new transports.Console({
      format: combine(splat(), timestamp(), consoleLogFormat),
    }),
  ],
});

if (["production", "development"].includes(environment.stage)) {
  const options: CloudwatchTransportOptions = {
    logGroupName: "portal-frontend",
    logStreamName: environment.stage,
    messageFormatter: awsLogFormat,
    awsRegion: process.env.REACT_APP_CLOUDWATCH_REGION,
    awsAccessKeyId: process.env.REACT_APP_CLOUDWATCH_ACCESS_KEY_ID,
    awsSecretKey: process.env.REACT_APP_CLOUDWATCH_SECRET_KEY,
  };

  const hasMissingOptions = Object.values(options).filter((x) => !x).length > 0;
  if (hasMissingOptions) {
    console.warn(
      "Missing Cloudwatch configuration options, remote logging will be disabled"
    );
  } else {
    logger.add(new WinstonCloudWatch(options));
  }
}

export default logger;
